import React from 'react'
import { Link } from 'gatsby'
import SbEditable from 'storyblok-react'

import TextRenderer from '../TextRenderer'
import ButtonPrimary from '../ButtonPrimary'

import styles from './styles.module.scss'

const PopupModal = (props) => {

    const content = JSON.parse(props.blok.content)

    return (
        <SbEditable content={props.blok}>
            <section className={styles['popup__inner']}>
                <Link to={props.closeTo} className={`button ${styles['popup__close']}`}>✕</Link>
                <div className='container'>
                    <div className={styles['member__author-wrapper']}>
                        {content.image.filename && <img src={content.image.filename} className={styles['member__author-image']} alt={content.image.alt} />}
                        <div className={styles['member__author-info']}>
                            <h1 className={`heading-4 ${styles['member__author-name']}`}><b>{content.name}</b></h1>
                            <span className={`body ${styles['member__author-title']}`}>{content.title}</span>
                        </div>
                    </div>
                    <TextRenderer text={content.description} />
                </div>
            </section>
		</SbEditable>
    )
}

export default PopupModal
